<template>
    <div class="pcga-tab">
        <vxe-toolbar
            size="small"
            perfect
            :export="true"
            :refresh="{ query: refreshData }"
            :print="true"
        >
            <template #buttons>
                <vxe-input
                    v-model="key_w"
                    type="search"
                    placeholder="Search table"
                    @change="searchEvent"
                    style="margin-left:0.3vw;"
                ></vxe-input>
            </template>
        </vxe-toolbar>
        <vxe-table
            :row-key="true"
            ref="xTable"
            row-id="id"
            :loading="loading"
            :data="list1"
            style="font-family: Arial, Helvetica, sans-serif;color:#000000"
            size="small"
            border="full"
            max-height="500"
            :export-config="{}"
            :query="loadData"
            :sort-config="table_data.sortConfig"
            @sort-change="customSortMethod"
        >
            <vxe-table-column
                v-for="col in table_data.tableColumn"
                :key="col.field"
                :field="col.field"
                :title="col.title"
                :width="col.width"
                :title-help="col.msg"
                :sortable="col.sort"
                type="html"
            ></vxe-table-column>
            <vxe-column field="rate" title="Reliability" width="10%" :title-help="star_means" v-if="showRate">
                <template #default="{ row }">
                <el-rate
                v-model="row.rate"
                :max="3"
                disabled
                text-color="#ff9900"
                >
                </el-rate>
            </template>
            </vxe-column>

        </vxe-table>

        <!-- <vxe-grid
            ref="xTable"
            row-id="id"
            :loading="loading"
            :data="list1"
            style="font-family: Arial, Helvetica, sans-serif;color:#000000"
            size="small"
            border="full"
            max-height="500"
            :export-config="{}"
            :query="loadData"
            :sort-config="table_data.sortConfig"
            :columns="table_data.tableColumn"
            @sort-change="customSortMethod"
        >
        </vxe-grid> -->

        <vxe-pager
            :loading="loading"
            :current-page="tablePage.currentPage"
            :page-size="tablePage.pageSize"
            :total="tablePage.totalResult"
            :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
            @page-change="handletablePageChange"
            style="font-family: Arial, Helvetica, sans-serif;color:#000000"
            size="small"
            :page-sizes="[10, 20, 100, { label: 'Full', value: -1 }]"
            perfect
        ></vxe-pager>
    </div>
</template>

<script>
import {getWord,getLink} from '@/bus.js'
export default {
    props: ["table_data", "loading", "loadData","showRate"],
    data: function () {
        return {
            // loading: true,
            list1: [],
            key_w: '',
            filterTableData: [],
            tablePage: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 10,
            },
            // table_data: {
            //     tableColumn: [],
            //     tableData: [],
            //     sortConfig:{remote:true},
            // },
            star_means:{content:"Reliability of the association. Three bright stars mean Bonferroni family-wise error rate (FWER) < 0.01. Two bright stars mean Bonferroni FWER < 0.05.\
             One bright star means unadjusted P-value < 0.05. No bright star means unadjusted P-value > 0.05"}
        }
    },
    //   created() {
    //       this.searchEvent();
    //   },
    mounted: function () {
    },

    watch: {
        loading: function () {
            this.searchEvent();
        }
    },
    methods: {
        refreshData(){
            this.$refs.xTable.clearSort();
            this.loadData();
            this.$refs.xTable.sort(table_data.sortConfig.defaultSort.field, table_data.sortConfig.defaultSort.order);
        },
        searchEvent() {
            const filterName = getWord(this.key_w).trim().toLowerCase()
            if (filterName) {
                const filterRE = new RegExp(filterName, 'gi')
                var searchProps = [];
                var outProps=['p','mean','z','se','CondiECSP','ECSP','GeneScore'];
                for (var k in this.table_data.tableData[0]) {
                    if(outProps.indexOf(k)!=-1){
                        continue;
                    }
                    searchProps.push(k);
                }
                // const searchProps = ['name', 'role', 'age', 'address']
                const rest = this.table_data.tableData.filter(item => searchProps.some(key => getWord(item[key]).toLowerCase().indexOf(filterName) > -1))
                this.filterTableData = rest.map(row => {
                    const item = Object.assign({}, row)
                    searchProps.forEach(key => {
                        if(!getLink(item[key])){
                            item[key] = getWord(item[key]).replace(filterRE, match => `<span class="keyword-lighten">${match}</span>`)                            
                        }else{
                            item[key] = getLink(item[key])+'>'+ getWord(item[key]).replace(filterRE, match => `<span class="keyword-lighten">${match}</span>`)+'</a>'         
                        }
                    })
                    return item
                })
            } else {
                this.filterTableData = this.table_data.tableData
            }
            this.tablePage.currentPage = 1;
            this.getCurrentTable();
        },
        handletablePageChange({ currentPage, pageSize }) {
            this.tablePage.currentPage = currentPage
            this.tablePage.pageSize = pageSize
            this.loading = false
            this.getCurrentTable();

        },
        getCurrentTable() {
            this.tablePage.totalResult = this.filterTableData.length
            if (this.tablePage.pageSize == -1) {
                this.list1 = this.filterTableData;
            } else {
                this.list1 = this.filterTableData.slice((this.tablePage.currentPage - 1) * this.tablePage.pageSize, this.tablePage.currentPage * this.tablePage.pageSize);
            }
        },
        customSortMethod({column, property, order, sortBy, sortList, $event}) {
            // const { property, order } = sortItem
            let list = this.table_data.tableData.sort(function(a_arr, b_arr){
                let a=a_arr[property];
                let b=b_arr[property];
                if(parseFloat(a) && parseFloat(b)){
                    return a-b;
                }else{
                    return a.localeCompare(b);
                }})
            if (order === 'desc') {
                list.reverse()
            }
            this.tablePage.currentPage=1;
            this.table_data.tableData=list;
            this.filterTableData=list;
            this.getCurrentTable();
        }
    }
}
</script>



<style>
.vxe-table--render-default.size--mini .vxe-body--column:not(.col--ellipsis) {
    padding: 4px 0;
}

.vxe-table--render-default.size--small .vxe-body--column:not(.col--ellipsis) {
    padding: 6px 0;
}

.keyword-lighten {
    color: #000;
    background-color: #ffc400;
}
</style>



// WEBPACK FOOTER //
// src/components/plot/cell_table.vue